import React from 'react';
import TablaUltimoAcumuladoRPM from './TablaUltimoAcumuladoRPM';

const UltimoAcumuladoRPMPage = () => {
    return (
        <div>
            <TablaUltimoAcumuladoRPM />
        </div>
    );
};

export default UltimoAcumuladoRPMPage;